export function concatRouteStartingWithSlash(...partialPaths: string[]): string {
    return (
        "/" +
        partialPaths.reduce((a, b) => {
            return a + "/" + b;
        })
    );
}

export function safeJoinURL(baseUrl: string, path: string): URL {
    const normalizedBase = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/";
    return new URL(path, normalizedBase);
}

export function isHttpUrl(url: string) {
    try {
        const urlObject = new URL(url);
        return urlObject.protocol === "https:" || urlObject.protocol === "http:";
    } catch {
        return false;
    }
}
